import Axios from "@/plugins/axios";

class UserApi {
    confirmChangeEmail(token, oldEmail, newEmail) {
        return Axios.post('changeEmailConfirm', {
            old_email: oldEmail.trim(),
            new_email: newEmail.trim(),
            token: token
        })
    }

  updateProfile(userId, candidacy) {
    return Axios.post("api/user/" + userId + "/candidacy/update", {
      address: candidacy.address.trim(),
      birth_department: candidacy.birth_department.trim(),
      birthday: candidacy.birthday.trim(),
      birthplace: candidacy.birthplace.trim(),
      birthCityId: candidacy.birthCityFieldId ? candidacy.birthCityFieldId : "",
      city: candidacy.city,
      civility: candidacy.civility,
      firstname: candidacy.firstname.trim(),
      marriedname: candidacy.marriedname ? candidacy.marriedname.trim() : "",
      lastname: candidacy.lastname.trim(),
      nationality: candidacy.nationality,
      phone_number: candidacy.phone_number.trim(),
      youtubeLink: candidacy.youtubeLink || '',
      youtubeDiffusionAccept: !!candidacy.youtubeDiffusionAccept,
    });
  }

  updateEmailRequest(newEmail) {
    return Axios.post("api/changeEmailRequest", {
      new_email: newEmail.trim(),
    });
  }
}

export default new UserApi();
